<dx-popup
  #chatPopup
  *ngIf="connectionEstablished"
  minWidth="300"
  maxWidth="100%"
  minHeight="300"
  maxHeight="100%"
  [width]="'30%'"
  [height]="'20%'"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  [visible]="true"
  [shading]="false"
  [resizeEnabled]="true"
  position="left bottom"
  contentTemplate="popup-content"
  titleTemplate="popup-title"
  (onContentReady)="popupReady($event)"
>
  <div *dxTemplate="let data of 'popup-title'">
    <div class="toolbar">
      <dx-button class="bell" icon="bell" (onClick)="mute()" [type]="muted ? 'normal' : 'default'"></dx-button>
      <span class="label">{{ 'RemoteEmergencyDoctorChat' | transloco }}</span>
      <dx-button [icon]="open ? 'chevrondown' : 'chevronup'" (onClick)="toggle()"></dx-button>
    </div>
  </div>
  <div class="content" *dxTemplate="let data of 'popup-content'">
    <nida-web-chat-log [chatMessages]="chatMessages" (initialScroll)="onInitialScroll()"></nida-web-chat-log>
    <nida-web-chat-input (sendMessage)="onSendMessage($event)"></nida-web-chat-input>
  </div>
</dx-popup>
